import { BasicSharedObject, EnvGlobalsHandler } from "@goodgamestudios/core";
import { IEnvironmentGlobals } from "@goodgamestudios/core";

import SimpleCrypto from "simple-crypto-js";

export class Poker2SharedObject extends BasicSharedObject {

    private static readonly k: string = "GGSGGSGGSGGSGGSGGSGGSGGSGGS";

    public static ATTRIBUTE_SAVE_PASSWORD: string = "p_save";
    public static ATTRIBUTE_CLIENT_INSTANCE: string = "clientinstance";

    protected encrypt(token: string): string {
        if (token !== null && token !== undefined && token !== "") {
            let simpleCrypto: SimpleCrypto = new SimpleCrypto(Poker2SharedObject.k);
            return simpleCrypto.encrypt(token);
        } else {
            return "";
        }
    }

    protected decrypt(token: string): string {
        if (token !== null && token !== undefined && token !== "") {
            if(token.substr(0, 60) == "GAaVBgmb9qjhJ4Nq3ikBxDxJMxPphwejw0pvenMnrnENkHOnqNzCxyYvcS2P") {
                let oldFlashPass = token.substring(60);
                return window.atob(oldFlashPass);
            }
            let simpleCrypto: SimpleCrypto = new SimpleCrypto(Poker2SharedObject.k);
            return <string>simpleCrypto.decrypt(token);
        } else {
            return "";
        }
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    public saveLoginData(username: string, pass: string, save?: boolean): void {
        this.networkCookie.saveLoginData(username, this.encrypt(pass));
        this.networkCookie.setAttribute(Poker2SharedObject.ATTRIBUTE_SAVE_PASSWORD, save === true);
    }

    public deleteLoginData(): void {
        this.networkCookie.deleteAttribute(Poker2SharedObject.ATTRIBUTE_SAVE_PASSWORD, false);
        super.deleteLoginData();
    }

    public readLoginDataUsername(): string {
        return super.readLoginDataUsername();
    }

    public readLoginDataPass(): string {
        return this.decrypt(super.readLoginDataLoginToken());
    }

    public readLoginDataSave(): boolean {
        return this.networkCookie.getAttributeAsBoolean(Poker2SharedObject.ATTRIBUTE_SAVE_PASSWORD);
    }

    public get cookieExists(): boolean {
        return this.networkCookie.getAttributeAsBoolean("cookieexists");
    }

    public saveCookieExists(): void {
        this.networkCookie.setAttribute("cookieexists", true);
    }

    public saveClientInstance(hash: number): void {
        this.networkCookie.setAttribute(Poker2SharedObject.ATTRIBUTE_CLIENT_INSTANCE, hash);
    }

    public readClientInstance(): number {
        return this.networkCookie.hasAttribute(Poker2SharedObject.ATTRIBUTE_CLIENT_INSTANCE) ?
            this.networkCookie.getAttributeAsNumber(Poker2SharedObject.ATTRIBUTE_CLIENT_INSTANCE) :
            -1;
    }
}
